import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

import Study from '../../domain/services/teacher/study/Study';

interface IInitialState {
  loading: 'idle' | 'pending' | 'success' | 'failed';
  response: object;
  error: string;
}

const initialState: IInitialState = {
  loading: 'idle',
  response: [],
  error: null,
};

export const getSubjectsThunk = createAsyncThunk(
  'get-study-subjects-for-class',
  async (arg: string) => {
    return new Study().getMySubjects({ _eq: arg });
  }
);

const StudySubjectsSlice = createSlice({
  name: 'teacher-study-subjects',
  reducers: {},
  initialState,
  extraReducers: builder => {
    builder.addCase(getSubjectsThunk.pending, state => {
      state.loading = 'pending';
    });
    builder.addCase(getSubjectsThunk.fulfilled, (state, action) => {
      state.loading = 'success';
      state.response = action.payload;
    });
    builder.addCase(getSubjectsThunk.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    });
  },
});

const reducerState = state => state.studySubjectsSlice;

export const studySubjectsState = createSelector(reducerState, items => {
  return {
    subjects: items.response,
    subjects_loading: items.loading,
  };
});

export default StudySubjectsSlice.reducer;
